import { Panel } from '../ui/Panel';
import { Toggle } from '../ui/Toggle';
import { useSettings } from './useSettings';
import { resolveFeatures } from '../../core/rules/features';
import type { SiteFeatures } from '../../core/types/site';

/** Instellingen › Koppelingen & privacy › Onderdelen: wat er op de site aan staat (LARAVEL.md §20a). Geldt na opslaan. */
export function FeatureSettings() {
  const {
    site,
    setSite
  } = useSettings();
  const features = resolveFeatures(site.features);
  const set = (patch: Partial<SiteFeatures>) => setSite(s => ({
    ...s,
    features: {
      ...resolveFeatures(s.features),
      ...patch
    }
  }));
  return <>
      <Panel title="Onderdelen" description="Zet een onderdeel uit als het er nog niet klaar voor is. Uit betekent: klanten zien het nergens, en jij ziet het niet in het klantdossier. Bestaande gegevens blijven bewaard." data-id="element-3997" data-mp="l3ovyuxfefgh">
        <div className="space-y-5" data-id="element-3998" data-mp="3opdu7ud1jwh5">
          <Toggle checked={features.diary} onChange={diary => set({
          diary
        })} label="Fotodagboek" description="Pas aanzetten na de DPIA: huidfoto's zijn gezondheidsgegevens. Uit: geen tab Fotodagboek in Mijn omgeving, geen dagboekkaartjes en geen tab Fotodagboek in het dossier." data-id="element-3999" data-mp="3jt5henmbgfd5" />
          <Toggle checked={features.subscriptions} onChange={subscriptions => set({
          subscriptions
        })} label="Bewust Abonnement" description="Uit: geen abonnementsblok op de site, geen keuze “Automatisch bijvullen” bij een product, in de winkelmand of bij afrekenen, en geen abonnement in Mijn omgeving of het dossier." data-id="element-4000" data-mp="3dygkq3ve5nmf" />
          <Toggle checked={features.prepaidKuur} onChange={prepaidKuur => set({
          prepaidKuur
        })} label="Kuur vooruit betalen" description="Uit: geen knop “Kuur vooruit betalen” bij de behandelingen, een kuur in de winkelmand valt weg, en aan de kassa is hij niet te kiezen. Lopende vooruitbetaalde kuren werken gewoon door, ook stoppen en terugbetalen." data-id="element-4001" data-mp="2v6fg0kvxr353" />
        </div>
      </Panel>

      <Panel title="Inzicht" description="Wat de site meet en vraagt, en wat je zelf krijgt. Alles anoniem en zonder cookies; de privacyverklaring zegt precies dit." data-id="element-4002" data-mp="3lz4hqh0d0h3r">
        <div className="space-y-5" data-id="element-4003" data-mp="3vuz5trncr4dx">
          <Toggle checked={features.analytics} onChange={analytics => set({
          analytics
        })} label="Bezoekers tellen" description="Telt bezoeken, waar ze vandaan komen en wat er gezocht wordt (Umami op de eigen server). Nooit op afrekenen, je bestelling, Mijn omgeving of het beheer. Uit: het script laadt niet meer en Inzicht › Bereik › Bezoekers blijft leeg." data-id="element-4004" data-mp="3qwed0dafjmzi" />
          <Toggle checked={features.acquisitionQuestion} onChange={acquisitionQuestion => set({
          acquisitionQuestion
        })} label="Vragen “Hoe kwam je bij ons?”" description="Eén vrijwillige tik na betalen, bij een eerste afspraak en aan de kassa bij een nieuwe klant. Voedt het tabblad Bronnen. Uit: de vraag staat nergens meer; bestaande antwoorden blijven." data-id="element-4005" data-mp="385d4oynf6f3a" />
          <Toggle checked={features.weeklySummary} onChange={weeklySummary => set({
          weeklySummary
        })} label="Wekelijkse samenvatting per mail" description="Elke maandag om 08:00 de belangrijkste cijfers en wat je deze week kunt doen, naar jouw adres. Alleen voor jou, niet voor medewerkers." data-id="element-4006" data-mp="zqyjoo2jnp0r" />
        </div>
        <p className="mt-6 border-t border-line pt-4 text-[13px] text-muted" data-id="element-4007" data-mp="1ioiy117on574">Geldt zodra je opslaat. Open pagina's bij klanten werken bij na herladen.</p>
      </Panel>
    </>;
}